import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      stroke={props.color || "currentColor"}
      strokeLinecap="round"
      strokeOpacity={0.6}
      strokeWidth={1.5}
      d="M3.8 9.333h2.333M3.8 6.416h4.666M5.841 12.833h.583M4.38 12.833c-.67-.015-1.121 0-1.704-.132-.612-.16-.991-.54-1.122-1.298-.132-.495-.09-2.698-.088-4.797.001-1.63.012-3.107.146-3.413.19-.656.627-1.123 1.982-1.137m5.756 0c.467.043 1.686 0 1.924 1.341.13.73.102 1.765.102 3.004M4.774 3.208c.612.014 2.58 0 3.25 0 .67 0 1.025-.552 1.02-1.065-.004-.522-.466-.93-.918-.977H4.76c-.54.03-.904.467-.962.904a1.026 1.026 0 0 0 .976 1.138ZM10.662 8.384c-.802.817-2.346 2.275-2.346 2.378-.125.173-.234.525-.306 1.02-.092.46-.202.86-.073.977.128.117.61.019 1.122-.087.408-.044.787-.19.976-.335.277-.246 2.157-2.144 2.376-2.392.16-.219.175-.627.035-.875-.079-.175-.575-.642-.735-.773a.886.886 0 0 0-1.05.087Z"
    />
  </svg>
)
export default SvgComponent
